import { render, staticRenderFns } from "./BaseSearchInput.vue?vue&type=template&id=2f6ffcd6&scoped=true"
import script from "./BaseSearchInput.vue?vue&type=script&lang=js"
export * from "./BaseSearchInput.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchInput.vue?vue&type=style&index=0&id=2f6ffcd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ffcd6",
  null
  
)

export default component.exports